import type {
  Alert,
  Follow,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAlerts } from "./useAlerts"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"
import { useAccount } from "src/hooks/account/useAccount"

export function useAlert(
  alertType: Alert["alert_type"],
  followingAccountId?: Follow["following_account_id"],
) {
  const { data: alerts } = useAlerts()
  const { data: account } = useAccount()
  const { currentUserId } = useFollowedUsers()

  const userId = followingAccountId ?? currentUserId

  return useMemo(
    () => alerts?.find(
      (cachedAlert) => (
        cachedAlert.account_id === account?.id &&
        cachedAlert.following_account_id === userId &&
        cachedAlert.alert_type === alertType
      ),
    ),
    [
      userId,
      alerts,
      account?.id,
      alertType,
    ],
  )
}
